// Panel 3 — Ranking de supervisores del día (mockup "Ranking de supervisores").
// La producción se atribuye por turnos cubiertos (programacion_supervisores),
// siempre vs capacidad instalada — no existe programa por turno.

import type { PantallaDatos } from 'schemas';
import { Barra, colorPct, Corona, fmt, nombreCorto, PanelVacio, TituloPanel } from '../shared';

export function PanelSupervisores({ datos }: { datos: PantallaDatos }) {
  const supervisores = datos.supervisores.slice(0, 4);

  return (
    <section className="flex h-full flex-col gap-6 px-[4vw] py-[3vh]">
      <TituloPanel
        titulo="Ranking de supervisores"
        subtitulo="Cumplimiento de sus grupos · producción supervisada vs capacidad"
      />
      {supervisores.length === 0 ? (
        <PanelVacio mensaje="Sin producción supervisada en la jornada todavía" />
      ) : (
        <div className="flex min-h-0 flex-1 flex-col justify-center gap-[2.2vh]">
          {supervisores.map((s, i) => {
            const primero = i === 0;
            return (
              <div
                key={s.user_id}
                className="grid grid-cols-[2.4rem_minmax(8rem,14rem)_minmax(0,1fr)_5rem] items-center gap-x-4 rounded-xl border border-border bg-surface-elevated px-5 lg:grid-cols-[3.4rem_minmax(16rem,22rem)_minmax(0,1fr)_8rem] lg:gap-x-8 lg:px-8"
                style={{
                  paddingBlock: 'clamp(1rem, 2.6vh, 2rem)',
                }}
              >
                <span className="text-fg-tertiary" style={{ fontVariantNumeric: 'tabular-nums' }}>
                  {primero ? (
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-md border border-border-strong text-fg">
                      <Corona size={20} />
                    </span>
                  ) : (
                    <span className="text-[1.4rem]">{i + 1}</span>
                  )}
                </span>
                <span className="min-w-0">
                  <span className="block truncate text-[clamp(1.2rem,1.7vw,1.9rem)] font-medium text-fg">
                    {nombreCorto(s.nombre, s.apellido)}
                  </span>
                  <span className="mt-1 block text-[0.85rem] text-fg-tertiary">
                    {s.lideres} líder{s.lideres === 1 ? '' : 'es'} a cargo
                  </span>
                </span>
                <span className="min-w-0">
                  <span className="mb-2 flex items-baseline justify-between text-[0.85rem] text-fg-secondary">
                    <span style={{ fontVariantNumeric: 'tabular-nums' }}>
                      {fmt.format(s.producido)} de {s.esperado > 0 ? fmt.format(s.esperado) : '—'}{' '}
                      paq
                    </span>
                    <span style={{ fontVariantNumeric: 'tabular-nums' }}>
                      {s.validaciones} validaci{s.validaciones === 1 ? 'ón' : 'ones'}
                      {s.invalidaciones > 0 ? ` · ${s.invalidaciones} inval.` : ''}
                    </span>
                  </span>
                  <Barra pct={s.cumplimiento_pct} height={12} />
                </span>
                <span
                  className="text-right text-[clamp(1.6rem,2.4vw,2.8rem)] font-medium leading-none"
                  style={{
                    color: colorPct(s.cumplimiento_pct),
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {s.cumplimiento_pct === null ? '—' : Math.round(s.cumplimiento_pct)}
                  <span className="text-[0.5em]">%</span>
                </span>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
